import { ResultObjectType } from '@cbgms/api'
import { ResultTitle } from './Title'
import { Box, Grid, Typography } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import { VirtualSearchResultType } from './TopSearchResultType'

export interface CallToActionSearchPartsResultProps {
  Type: VirtualSearchResultType.CallToActionSearchParts
  query: string
  clearQuery: () => void
  primaryAction: () => Promise<void>
  hasGroupHeader: boolean
}

const gridSize = { resultSize: 12 }
const CallToActionSearchPartsResult: React.FC<CallToActionSearchPartsResultProps> = ({ hasGroupHeader, query, primaryAction }) => {
  const { t } = useTranslation()

  const onClickViewParts = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.stopPropagation()
      primaryAction()
    },
    [primaryAction]
  )

  return (
    <Grid container key='search-parts-with-query' spacing={0} sx={{ margin: 0, padding: 0, cursor: 'pointer' }} onClick={onClickViewParts}>
      <Grid item xs={gridSize.resultSize}>
        <Box sx={{ display: 'inline-flex', flexWrap: 'no-wrap', justifyContent: 'flex-start', '&>*': { flex: '1 1 auto', mr: 1 } }}>
          <Box sx={{ display: 'inline-block', mr: 2, paddingRight: '1rem', maxHeight: '1rem' }}>
            <Box sx={{ position: 'absolute', opacity: 0.7 }}>
              <SearchIcon />
            </Box>
          </Box>
          <ResultTitle resultType={ResultObjectType.Parts} isTitleVisible={!hasGroupHeader} />
          <Typography sx={{ pr: 1 }}>{t('global.search_products_now', { query })}</Typography>
        </Box>
      </Grid>
    </Grid>
  )
}

export default CallToActionSearchPartsResult
